/* Bazaar Bee cart page + cart drawer (approved cart mockup): quantity/upgrade/remove/add-ons/coupon,
   live re-render through the Section Rendering API, drawer opening after every add to cart. */
(() => {
  if (window.BBK) return;
  window.BBK = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const H = document.documentElement;
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function dates(scope) {
    const n = new Date(), m = new Date(n); m.setHours(24, 0, 0, 0);
    const s = Math.floor((m - n) / 1000);
    const cd = Math.floor(s / 3600) + 'h ' + String(Math.floor((s % 3600) / 60)).padStart(2, '0') + 'm';
    $$('[data-bbk-cd]', scope).forEach((e) => (e.textContent = cd));
    $$('[data-bbk-eta]', scope).forEach((e) => {
      const days = +(e.closest('[data-bbk-days]')?.dataset.bbkDays || 7);
      const d = new Date(); d.setDate(d.getDate() + days);
      e.textContent = `${d.toLocaleDateString('en-IN', { weekday: 'short' })} ${d.getDate()} ${d.toLocaleDateString('en-IN', { month: 'short' })}`;
    });
  }

  const roots = () => $$('[data-bbk-root]');
  async function rerender(cart) {
    const ids = roots().map((r) => r.dataset.sectionId).filter(Boolean);
    if (ids.length) {
      try {
        const res = await fetch(`${location.pathname}?sections=${ids.join(',')}`);
        const data = await res.json();
        roots().forEach((r) => {
          const html = data[r.dataset.sectionId];
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector(`[data-bbk-root][data-section-id="${r.dataset.sectionId}"]`);
          if (fresh) r.innerHTML = fresh.innerHTML;
          dates(r);
        });
      } catch (e) {}
    }
    try {
      cart = cart || (await (await fetch(`${root}cart.js`)).json());
      $$('#bb-cart-drawer .bbk-dh span').forEach((e) => (e.textContent = cart.item_count));
      document.querySelectorAll('cart-icon').forEach((el) => el.renderCartBubble && el.renderCartBubble(cart.item_count));
      document.dispatchEvent(new CustomEvent('bb:cart:changed', { detail: cart }));
    } catch (e) {}
  }

  const drawer = () => document.getElementById('bb-cart-drawer');
  function open(justAdded) {
    if (!drawer()) return false;
    H.classList.toggle('bbk-just-added', !!justAdded);
    H.classList.add('bbk-open');
    drawer().focus({ preventScroll: true });
    return true;
  }
  function close() { H.classList.remove('bbk-open', 'bbk-just-added'); }

  async function busy(el, fn) {
    const box = el.closest('[data-bbk-root]');
    box && box.classList.add('bbk-busy');
    try { await fn(); } catch (e) { alert('Sorry, the cart could not be updated. Please try again.'); }
    box && box.classList.remove('bbk-busy');
  }

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-bb-cart-open]')) {
      if (drawer()) { e.preventDefault(); rerender().then(() => open(false)); open(false); }
      return;
    }
    if (t.closest('[data-bbk-close]')) { e.preventDefault(); close(); return; }

    const q = t.closest('[data-bbk-qty]');
    if (q) {
      e.preventDefault();
      const key = q.closest('[data-key]')?.dataset.key;
      if (!key) return;
      H.classList.remove('bbk-just-added');
      busy(q, async () => {
        const r = await fetch(`${root}cart/change.js`, { method: 'POST', headers: json, body: JSON.stringify({ id: key, quantity: +q.dataset.bbkQty }) });
        if (!r.ok) throw new Error(String(r.status));
        await rerender(await r.json());
      });
      return;
    }
    const a = t.closest('[data-bbk-add]');
    if (a) {
      e.preventDefault();
      busy(a, async () => {
        const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: +a.dataset.bbkAdd, quantity: 1 }] }) });
        if (!r.ok) throw new Error(String(r.status));
        await rerender();
      });
      return;
    }
    const b = t.closest('[data-bbk-buy]');
    if (b) {
      e.preventDefault();
      b.disabled = true;
      fetch(`${root}cart.js`, { headers: json }).then((r) => r.json()).catch(() => ({ items: [] }))
        .then((c) => ((c.items || []).some((i) => i.variant_id === +b.dataset.bbkBuy) ? { ok: true } // already in the cart: don't add it again
          : fetch(`${root}cart/add.js`, { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: +b.dataset.bbkBuy, quantity: 1 }] }) })))
        .then((r) => { if (!r.ok) throw new Error(); if (window.bbCheckout) { b.disabled = false; window.bbCheckout(); } else location.href = `${root}checkout`; }) // bbCheckout: our COD form (assets/bb-cod.js)
        .catch(() => { b.disabled = false; alert('Sorry, this item could not be added. Please try again.'); });
    }
  });

  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-bbk-coupon]');
    if (!f) return;
    e.preventDefault();
    const code = (f.querySelector('input').value || '').trim();
    if (code) location.href = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(location.pathname)}`;
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && H.classList.contains('bbk-open') && !H.classList.contains('bbcod-open')) close(); });

  // open the drawer after any add to cart: our own buttons fire bb:cart:added, Horizon's product form fires shopify:cart:lines-update
  document.addEventListener('bb:cart:added', () => rerender().then(() => open(true)));
  document.addEventListener('shopify:cart:lines-update', (e) => {
    // Horizon fires this before its request finishes; e.promise resolves once the cart is updated
    const go = () => rerender().then(() => open(true));
    const p = e.promise || (e.detail && e.detail.promise);
    if (p && typeof p.then === 'function') p.then(go, () => {}); else setTimeout(go, 1200);
  });

  const init = () => { dates(document); setInterval(() => dates(document), 30000); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
